import web from "../web";

class PersonnesService {
    index(token){
        return web.get("/api/personnes", { headers: { 'Authorization': 'Bearer '+token  } })
    }
   
}

export default new PersonnesService()